import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Col, Row } from 'reactstrap'
import { withTranslation } from 'react-i18next';

// Import SVG files
import mastercardSvg from '../img/payment_methods/card_mastercard.svg';
import visaSvg from '../img/payment_methods/card_visa.svg';
import postfinanceSvg from '../img/payment_methods/card_post-finance-pay.svg';
import twintSvg from '../img/payment_methods/card_twint.svg';
import paypalSvg from '../img/payment_methods/card_paypal.svg';
import applePaySvg from '../img/payment_methods/card_apple-pay.svg';
import googlePaySvg from '../img/payment_methods/card_google-pay.svg';
import samsungPaySvg from '../img/payment_methods/card_samsung-pay.svg';
import amexSvg from '../img/payment_methods/card_american-express.svg';
import dinersSvg from '../img/payment_methods/card_diners-club.svg';
import klarnaSvg from '../img/payment_methods/card_klarna.svg';

class Footer extends Component {
    shouldShowOldHours() {
        const switchDate = new Date('2025-06-01T00:00:00+02:00'); // Swiss time
        return new Date() < switchDate;
    }

    render() {
        const { t } = this.props;
        return (
            <footer className="main-footer" style={{paddingBottom: '80px'}}>
                <div className="main-block">
                    <div className="container pt-3 pb-3">
                        <Row className="justify-content-md-center">
                            <Col sm="4">
                                <Row className="align-items-center">
                                    <Col md="auto">
                                        <img style={{ height: '120px', width: '120px' }}
                                            src={require("../img/logo_white.png")}
                                            alt={t('footer.logoAlt')}
                                        />
                                    </Col>
                                    <Col className="align-self-center" md="auto" style={{ fontSize: "15px", color: "white" }}>
                                        <Row><Col>Hohlstrasse 192</Col></Row>
                                        <Row><Col>8004 Zürich</Col></Row>
                                        <Row><Col>044 304 22 98</Col></Row>
                                        <Row><Col>info@woes.ch</Col></Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col className="align-self-center" sm="2" style={{ fontSize: "15px", color: "white" }}>
                                <Row>
                                    <Link to="/agb" style={{ color: "white" }}>{t('footer.links.terms')}</Link>
                                </Row>
                                <Row>
                                    <Link to="/privacy" style={{ color: "white" }}>{t('footer.links.privacy')}</Link>
                                </Row>
                                <Row>
                                    <Link to="/imprint" style={{ color: "white" }}>{t('footer.links.imprint')}</Link>
                                </Row>
                                <Row className="Link2">
                                    <Link to={this.props.i18n.language === 'en' ? '/en/faq' : '/faq'} style={{ color: "white" }}>{t('footer.links.faq')}</Link>
                                </Row>
                            </Col>
                            <Col className="align-self-center" sm="4" style={{ fontSize: "15px", color: "white" }}>
                                <Row><Col>{t(this.shouldShowOldHours() ? 'footer.hoursold.title' : 'footer.hours.title')}</Col></Row>
                                <Row>
                                    <Col>{t(this.shouldShowOldHours() ? 'footer.hoursold.weekdays' : 'footer.hours.weekdays')}</Col>
                                    <Col>{t(this.shouldShowOldHours() ? 'footer.hoursold.weekdayHours' : 'footer.hours.weekdayHours')}</Col>
                                </Row>
                                {this.shouldShowOldHours() && (
                                    <Row>
                                        <Col>{t('footer.hoursold.saturday')}</Col>
                                        <Col>{t('footer.hoursold.saturdayHours')}</Col>
                                    </Row>
                                )}
                                <Row>
                                    <Col>{t(this.shouldShowOldHours() ? 'footer.hoursold.online' : 'footer.hours.online')}</Col>
                                    <Col>{t(this.shouldShowOldHours() ? 'footer.hoursold.onlineHours' : 'footer.hours.onlineHours')}</Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="justify-content-md-center" style={{ marginTop: "40px" }}>
                            <div style={{ 
                                display: 'flex', 
                                flexWrap: 'wrap', 
                                gap: '15px', 
                                justifyContent: 'center',
                                maxWidth: '500px',
                                margin: '0 auto'
                            }}>
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={twintSvg}
                                    alt={t('footer.payments.twint')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={mastercardSvg}
                                    alt={t('footer.payments.mastercard')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={visaSvg}
                                    alt={t('footer.payments.visa')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={postfinanceSvg}
                                    alt={t('footer.payments.postfinance')}
                                    loading="lazy"
                                />
                                
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={paypalSvg}
                                    alt={t('footer.payments.paypal')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={klarnaSvg}
                                    alt={t('footer.payments.klarna')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={applePaySvg}
                                    alt={t('footer.payments.applePay')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={googlePaySvg}
                                    alt={t('footer.payments.googlePay')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={samsungPaySvg}
                                    alt={t('footer.payments.samsungPay')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={amexSvg}
                                    alt={t('footer.payments.amex')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={dinersSvg}
                                    alt={t('footer.payments.diners')}
                                    loading="lazy"
                                />
                                <img style={{ width: '60px', height: "40px", borderRadius: '6px' }}
                                    src={require("../img/payment_methods/gift_card.png")}
                                    alt={t('footer.payments.giftCard')}
                                    loading="lazy"
                                />
                            </div>
                        </Row>
                    </div>
                </div>
            </footer>
        );
    }
}

export default withTranslation()(Footer);